import styled, {css} from "styled-components";
import React from "react";
import {observer} from "mobx-react";
import {NullableString} from "../../../../../types/nullable-types";

export const FieldsContainer2ColumnsBox = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    row-gap: ${props => props.theme.spacing.flexGap16};
    ${props => props.theme.containerMediaQuery.smallScreen} {
        grid-template-columns: 1fr;
    }
`

const ProfileFieldBox = styled.div<{$fullWidth: boolean; $isLastOne: boolean}>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
    width: 100%;
    gap: 4px;
    padding-bottom: ${props => props.theme.spacing.spacing16};
    
    ${props => !props.$isLastOne && css`
        border-bottom: 1px solid ${props => props.theme.border.mainColor};
    `}
    
    ${props => props.$fullWidth && css`
        grid-column: 1/-1;
    `}
`;


const ProfileFieldLabelBox = styled.div`
    color: ${props => props.theme.colors.dark};     
    font-size: ${props => props.theme.fontSize.subtitle1};
`;

const ProfileFieldValueBox = styled.div`
    color: ${props => props.theme.colors.primary};  
    font-size: ${props => props.theme.fontSize.h5};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    min-height: ${props => props.theme.fontSize.h5};
`;


interface ProfileFieldComponentProps {
    label: string;
    value: NullableString | React.ReactElement;
    fullWidth?: boolean;
    isOnLastRow?: boolean;
}

export const ProfileFieldComponent: React.FC<ProfileFieldComponentProps> = observer((props) => {
    return (
        <ProfileFieldBox $fullWidth={Boolean(props.fullWidth)}
                         $isLastOne={Boolean(props.isOnLastRow)}>
            <ProfileFieldLabelBox>{props.label}</ProfileFieldLabelBox>
            <ProfileFieldValueBox>{props.value}</ProfileFieldValueBox>
        </ProfileFieldBox>
    );
})